<template>
  <div>
    <div class="title-block">座席指定方法</div>
    <div class="column">
      <div class="radio-wrap two-side">
        <div class="radio">
          <input
            id="radio-1"
            v-model="seatSelectionRadio"
            name="radio1"
            type="radio"
            :value="0"
            :disabled="isDisabledRadio"
          />
          <label for="radio-1" class="radio-label">条件で指定</label>
        </div>
        <div class="radio">
          <input
            id="radio-2"
            v-model="seatSelectionRadio"
            name="radio1"
            type="radio"
            :value="1"
          />
          <label for="radio-2" class="radio-label">シートマップで指定</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watch, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";
import { CAR_SPECIAL_DESIGNATIONS_LIST } from "@/lib/constants";

export default {
  name: "MFITTBookingSeatSelectionMethod",
  props: {
    selectedSeatType: {
      required: true,
    },
    seatSelectionRadio: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const selectedSeatType = useVModel(props, "selectedSeatType");
    const seatSelectionRadio = useVModel(props, "seatSelectionRadio");
    // 一般席以外はシートマップで指定で固定で、条件で指定はdisableにする

    const isDisabledRadio = computed(() =>
      CAR_SPECIAL_DESIGNATIONS_LIST.includes(
        selectedSeatType.value.cars_special_designation
      )
    );

    // 席種類の変更を感知して、一般席以外はシートマップで指定に固定コントロール
    watch(
      () => selectedSeatType.value,
      (selectedSeatType) => {
        if (isDisabledRadio.value) {
          seatSelectionRadio.value = 1;
        }
        console.log("selectedSeatType :>> ", selectedSeatType);
      }
    );
    return {
      seatSelectionRadio,
      isDisabledRadio,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.float-text {
  float: right;
  font-weight: normal;
}

.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}

/* ラジオボタン */
.radio-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px;
}
.radio-wrap {
  justify-content: space-between;
}
.radio {
  margin: 0.5rem !important;
}
.radio input[type="radio"] {
  position: absolute;
  opacity: 0;
}
.radio input[type="radio"] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.2em;
  margin-right: 1em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type="radio"]:checked + .radio-label:before {
  background-color: #ff7600;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type="radio"]:focus + .radio-label:before {
  outline: none;
  border-color: #ff7600;
}
.radio input[type="radio"]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type="radio"] + .radio-label:empty:before {
  margin-right: 0;
}

.radio-wrap.two-side {
  justify-content: flex-start;
}
.radio-wrap.two-side .radio {
  width: calc(50% - 1rem);
}
</style>
